export const FETCH_SERVICE_USAGE_REQUEST = '[ServiceUsage] FETCH_SERVICE_USAGE_REQUEST';
export const FETCH_SERVICE_USAGE_SUCCESS = '[ServiceUsage] FETCH_SERVICE_USAGE_SUCCESS';
export const FETCH_SERVICE_USAGE_FAILURE = '[ServiceUsage] FETCH_SERVICE_USAGE_FAILURE';
